import React from 'react';
import Box, { BoxProps } from '../ui/Box';
import Txt, { TxtProps } from '../ui/Txt';

export type SideBar = BoxProps<
  'div',
  {
    TxtProps?: TxtProps;
    content?: string;
  }
>;

export default function Sidebar({ content, TxtProps, ...props }: SideBar) {
  return (
    <Box as="aside" {...props}>
      <Txt html {...TxtProps}>
        {content}
      </Txt>
    </Box>
  );
}
